import * as React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { flow } from 'lodash';
import { Field, formValueSelector } from 'redux-form';
import FieldFormControl from '../../../../components/FieldFormControl/index';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { IStore } from '../../../../redux/IStore';
import { FaCheck, FaExclamationTriangle } from 'react-icons/fa';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';

interface IVoucherCodeProps {
  quote: IQuoteState;
  campaignCode: string;
  dispatch: any;
  change: any;
  actions: {
    quote: IQuoteActions;
  };
  enabled: boolean;
}

class VoucherCode extends React.Component<IVoucherCodeProps> {
  public componentWillMount() {
    const { quote, actions, dispatch, change } = this.props;
    if (quote.campaignCode) {
      dispatch(change('campaignCode', quote.campaignCode));
      actions.quote.dispatchVoucherCode(quote.campaignCode);
    }
  }

  private checkVoucherCode = () => {
    const { actions, campaignCode } = this.props;

    actions.quote.checkVoucherCode(campaignCode);
  }

  private renderButtonMessage = () => {
    const { quote } = this.props;

    if (quote.voucherCodeStatus === 'success') {
      return <span>{quote.voucherCodeMessage} <FaCheck /></span>;
    }

    if (quote.voucherCodeStatus === 'error') {
      return <span>{quote.voucherCodeMessage} <FaExclamationTriangle /></span>;
    }

    return <span>Apply</span>;
  }

  public render() {
    const { quote, enabled } = this.props;

    return (
      <div style={{ display: enabled ? 'visible' : 'none' }}>
        <div className="section-title">
          <h4>Do you have a voucher code?</h4>
        </div>
        <div className="section-group">
          <div className="section">
            <Row>
              <Col sm={8} className={quote.voucherCodeStatus === 'error' && 'has-error'}>
                <Field
                  name="campaignCode"
                  placeholder={'Enter your voucher code...'}
                  component={FieldFormControl}
                  disabled={!enabled}
                  type={quote.voucherCodePreventDisplay ? 'password' : 'text'}
                />
              </Col>
              <Col sm={4}>
                <Button
                  bsStyle={quote.voucherCodeStatus === 'error' ? 'danger' : 'primary'}
                  block={true}
                  onClick={this.checkVoucherCode}
                  disabled={!enabled}
                >
                  {this.renderButtonMessage()}
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
connect(
  (state: IStore) => {
    const campaignCode = selector(state, 'campaignCode');

    return {
      quote: state.quote,
      campaignCode,
    };
  },
  (dispatch) => ({
    actions: {
      quote: bindActionCreators({...quoteActions}, dispatch),
    },
  }),
),
])(VoucherCode);
